import {useMemo} from 'react';

import CountryModel from 'coreClasses/countries/CountryModel';
import LanguageModel from 'coreClasses/languages/LanguageModel';

import useNotifyMe from 'sfccAPI/hooks/useNotifyMe';
import {useLocalesMgr, useCustomerMgr} from 'coreHooks';

/**
 * Hook for handling product subscription
 */
const useProductSubscription = () => {
	const notifyMe = useNotifyMe();
	const customerMgr = useCustomerMgr();
	const localesMgr = useLocalesMgr();
	const currentLanguage: LanguageModel = localesMgr.getCurrentLanguage();
	const currentCountry: CountryModel = localesMgr.getCurrentCountry();

	return useMemo(
		() => ({
			// @ts-expect-error original pattern
			async subscribe(email, pid, acceptsMarketing, source = '' || {}) {
				const isSubscribed = await customerMgr.getNewsletterProfile(email).then((res) => {
					return res.isSubscribed;
				});

				if (!isSubscribed) {
					if (acceptsMarketing) {
						const {subscriptionCode} = await customerMgr.subscribeToNewsletter(
							email,
							null,
							null,
							source,
							[],
							null,
							acceptsMarketing
						);

						if (subscriptionCode === 'OK') {
							await customerMgr.updateCustomerNewsletter(true);
						}
					} else {
						await customerMgr.createProfile(
							email,
							currentCountry.getCountryCode(),
							currentLanguage.getLanguageCode()
						);
					}
				}

				await notifyMe.createNotifyMe(
					email,
					pid,
				);
			}
		}), []);
};

export default useProductSubscription;
